import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import numeral from "numeral";
import { memo, useEffect, useState } from "react";

import { getRequest } from "../../../api/apiCaller";
import Dialog from "../../../components/Dialog";
import API_URL from "../../../constant/api-url";
import DataNotFound from "./DataNotFound";
import classes from "./TableReportCharge.module.css";

const TableReportCharge = ({ reportChargeFilter }) => {
  const [reportChargeData, setReportChargeData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { reportType } = reportChargeFilter; //= 2: cước viễn thông tạm tính theo đơn vị, =3: theo bưu điện tỉnh thành phố

  const getReportCharge = () => {
    setIsLoading(true);
    const url =
      reportType === 2.1 || reportType === 2.2
        ? API_URL.CLOUD_PBX_REPORT_IBC_OBC
        : API_URL.CLOUD_PBX_REPORT_IBC_OBC_EXT;

    getRequest(url, {
      filter: {
        where: reportChargeFilter.where,
      },
    })
      .then((res) => {
        setReportChargeData(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  useEffect(() => {
    if (reportChargeFilter) {
      getReportCharge();
    }
  }, [reportChargeFilter]);

  const formatNumber = (num) => numeral(num).format("0,0.00");

  const renderOnnetOffnetTotalFields = (item, index) => {
    return (
      <TableRow key={index}>
        <TableCell className={classes.tableBodyCell} align="center">
          {index + 1}
        </TableCell>
        <TableCell className={classes.tableBodyCell} align="center">
          {reportType === 2.1 || reportType === 2.2
            ? item.number
            : item.extensionName}
        </TableCell>
        {reportType === 3 && (
          <TableCell className={classes.tableBodyCell} align="center">
            {item.subOrgName || ""}
          </TableCell>
        )}

        <TableCell className={classes.tableBodyCell} align="center">
          {formatNumber(item.onnet)}
        </TableCell>
        <TableCell className={classes.tableBodyCell} align="center">
          {formatNumber(item.onnet_price)}
        </TableCell>
        <TableCell className={classes.tableBodyCell} align="center">
          {formatNumber(item.offnet)}
        </TableCell>
        <TableCell className={classes.tableBodyCell} align="center">
          {formatNumber(item.offnet_price)}
        </TableCell>
        <TableCell className={classes.tableBodyCell} align="center">
          {formatNumber(item.totalDuration)}
        </TableCell>
        <TableCell className={classes.tableBodyCell} align="center">
          {formatNumber(item.totalPrice)}
        </TableCell>
        {reportType === 3 && (
          <>
            <TableCell className={classes.tableBodyCell} align="center">
              {formatNumber(item.licensePrice)}
            </TableCell>
            <TableCell className={classes.tableBodyCell} align="center">
              {formatNumber(item.totalPrice + item.licensePrice)}
            </TableCell>
          </>
        )}
      </TableRow>
    );
  };

  const getTotalByField = (fieldName) => {
    const total = reportChargeData.reduce(
      (res, switchBoard) =>
        res +
        (switchBoard?.ip || [])
          .concat(switchBoard?.mobile || [])
          .concat(switchBoard?.cskh || [])
          .reduce((total, item) => total + item[fieldName], 0),
      0
    );
    return total;
  };

  const getTotalByManyFields = (...fields) => {
    return fields.reduce((prev, field) => prev + getTotalByField(field), 0);
  };
  console.log(reportChargeData);
  return (
    <>
      {reportChargeData && (
        <>
          <Paper style={{ color: "black", padding: 16 }}>
            {reportChargeData.length > 0 && (
              <div className={classes.tableContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ width: 60 }}
                        className={classes.tableBodyCell}
                        rowSpan={2}>
                        STT
                      </TableCell>
                      <TableCell
                        rowSpan={2}
                        align="center"
                        className={classes.tableBodyCell}>
                        {reportType === 2.1 || reportType === 2.2
                          ? "Đầu số MST gọi ra"
                          : "Số máy lẻ / Số bưu tá"}
                      </TableCell>
                      {reportType === 3 && (
                        <TableCell
                          rowSpan={2}
                          align="center"
                          className={classes.tableBodyCell}>
                          Đơn vị quản lý
                        </TableCell>
                      )}

                      <TableCell
                        colSpan={2}
                        align="center"
                        className={classes.tableBodyCell}>
                        Nội mạng
                      </TableCell>
                      <TableCell
                        colSpan={2}
                        align="center"
                        className={classes.tableBodyCell}>
                        Ngoại mạng
                      </TableCell>
                      <TableCell
                        colSpan={2}
                        align="center"
                        className={classes.tableBodyCell}>
                        Tổng cộng
                      </TableCell>
                      {reportType === 3 && (
                        <>
                          <TableCell
                            rowSpan={2}
                            align="center"
                            className={classes.tableBodyCell}>
                            Cước thuê bao license
                          </TableCell>
                          <TableCell
                            rowSpan={2}
                            align="center"
                            className={classes.tableBodyCell}>
                            Tổng tiền
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        className={classes.tableBodyCell}>
                        Sản lượng gọi (Phút)
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableBodyCell}>
                        Thành tiền
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableBodyCell}>
                        Sản lượng gọi (Phút)
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableBodyCell}>
                        Thành tiền
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableBodyCell}>
                        Sản lượng gọi (Phút)
                      </TableCell>
                      <TableCell
                        align="center"
                        className={classes.tableBodyCell}>
                        Thành tiền
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <>
                      {[2.2, 2.1].includes(reportType) &&
                        reportChargeData.map((switchBoard) => (
                          <>
                            <TableRow>
                              <TableCell
                                colSpan={99}
                                className={`${classes.tableBodyCell} ${classes.bold} ${classes.bgYellow}`}>
                                {`${switchBoard.displayName || ""}`}
                              </TableCell>
                            </TableRow>

                            {!!switchBoard.cskh?.length && (
                              <>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    style={{ borderRight: "none" }}
                                  />
                                  <TableCell
                                    colSpan={99}
                                    className={`${classes.tableBodyCell} ${classes.italic}`}
                                    style={{ borderLeft: "none" }}>
                                    Tổng đài CSKH
                                  </TableCell>
                                </TableRow>

                                {switchBoard.cskh.map((item, index) =>
                                  renderOnnetOffnetTotalFields(item, index)
                                )}
                              </>
                            )}

                            {!!switchBoard.ip?.length && (
                              <>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    style={{ borderRight: "none" }}
                                  />
                                  <TableCell
                                    colSpan={99}
                                    className={`${classes.tableBodyCell} ${classes.italic}`}
                                    style={{ borderLeft: "none" }}>
                                    Tổng đài bưu cục
                                  </TableCell>
                                </TableRow>

                                {switchBoard.ip.map((item, index) =>
                                  renderOnnetOffnetTotalFields(item, index)
                                )}
                              </>
                            )}

                            {!!switchBoard.mobile?.length && (
                              <>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    style={{ borderRight: "none" }}
                                  />
                                  <TableCell
                                    colSpan={99}
                                    className={`${classes.tableBodyCell} ${classes.italic}`}
                                    style={{ borderLeft: "none" }}>
                                    Tổng đài bưu tá
                                  </TableCell>
                                </TableRow>

                                {switchBoard.mobile.map((item, index) =>
                                  renderOnnetOffnetTotalFields(item, index)
                                )}
                              </>
                            )}
                          </>
                        ))}

                      {[3].includes(reportType) &&
                        reportChargeData.map((switchBoard) => (
                          <>
                            <TableRow>
                              <TableCell
                                colSpan={99}
                                className={`${classes.tableBodyCell} ${classes.bold} ${classes.bgYellow}`}>
                                {`${switchBoard.citycode || ""} - ${
                                  switchBoard.address || ""
                                }`}
                              </TableCell>
                            </TableRow>

                            {!!switchBoard.cskh?.length && (
                              <>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    style={{ borderRight: "none" }}
                                  />
                                  <TableCell
                                    colSpan={99}
                                    className={`${classes.tableBodyCell} ${classes.italic}`}
                                    style={{ borderLeft: "none" }}>
                                    Tổng đài CSKH
                                  </TableCell>
                                </TableRow>

                                {switchBoard.cskh.map((item, index) =>
                                  renderOnnetOffnetTotalFields(item, index)
                                )}
                              </>
                            )}

                            {!!switchBoard.ip?.length && (
                              <>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    style={{ borderRight: "none" }}
                                  />
                                  <TableCell
                                    colSpan={99}
                                    className={`${classes.tableBodyCell} ${classes.italic}`}
                                    style={{ borderLeft: "none" }}>
                                    Tổng đài bưu cục
                                  </TableCell>
                                </TableRow>

                                {switchBoard.ip.map((item, index) =>
                                  renderOnnetOffnetTotalFields(item, index)
                                )}
                              </>
                            )}

                            {!!switchBoard.mobile?.length && (
                              <>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    style={{ borderRight: "none" }}
                                  />
                                  <TableCell
                                    colSpan={99}
                                    className={`${classes.tableBodyCell} ${classes.italic}`}
                                    style={{ borderLeft: "none" }}>
                                    Tổng đài bưu tá
                                  </TableCell>
                                </TableRow>

                                {switchBoard.mobile.map((item, index) =>
                                  renderOnnetOffnetTotalFields(item, index)
                                )}
                              </>
                            )}
                          </>
                        ))}

                      <TableRow>
                        <TableCell
                          colSpan={
                            reportType === 2.1 || reportType === 2.2 ? 2 : 3
                          }
                          className={`${classes.tableBodyCell} ${classes.bold}`}
                          align="center">
                          Tổng cộng
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="center">
                          {formatNumber(getTotalByField("onnet"))}
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="center">
                          {formatNumber(getTotalByField("onnet_price"))}
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="center">
                          {formatNumber(getTotalByField("offnet"))}
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="center">
                          {formatNumber(getTotalByField("offnet_price"))}
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="center">
                          {formatNumber(getTotalByField("totalDuration"))}
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="center">
                          {formatNumber(getTotalByField("totalPrice"))}
                        </TableCell>
                        {reportType === 3 && (
                          <>
                            <TableCell
                              className={classes.tableBodyCell}
                              align="center">
                              {formatNumber(getTotalByField("licensePrice"))}
                            </TableCell>
                            <TableCell
                              className={classes.tableBodyCell}
                              align="center">
                              {formatNumber(
                                getTotalByManyFields(
                                  "licensePrice",
                                  "totalPrice"
                                )
                              )}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    </>
                  </TableBody>
                </Table>
              </div>
            )}
            {reportChargeData.length === 0 && <DataNotFound />}
          </Paper>
        </>
      )}
      {<Dialog open={isLoading} title={<CircularProgress />} />}
    </>
  );
};

export default memo(TableReportCharge);
